import { Transition } from '@headlessui/react'

export const delays = [
  'delay-0',
  'delay-50',
  'delay-100',
  'delay-150',
  'delay-200',
  'delay-250',
  'delay-300',
  'delay-350',
  'delay-400',
  'delay-450',
  'delay-500'
]

export const FadeIn = ({ delay, children }) => (
  <Transition.Child
    enter={`transition-all ease-in-out duration-500 ${delay}`}
    enterFrom='opacity-0 translate-y-4'
    enterTo='opacity-100 translate-y-0'
    leave='transition-all ease-in-out duration-300'
    leaveFrom='opacity-100'
    leaveTo='opacity-0'
  >
    {children}
  </Transition.Child>
)

export const FadeInOut = ({ enterDelay = '', exitDelay = '', children }) => (
  <Transition.Child
    enter={`transition-all ease-in-out duration-500 ${enterDelay}`}
    enterFrom='opacity-0 -translate-y-4'
    enterTo='opacity-100 translate-y-0'
    leave={`transition-all ease-in duration-300 ${exitDelay}`}
    leaveFrom='opacity-100 translate-y-0'
    leaveTo='opacity-0 translate-y-3'
  >
    {children}
  </Transition.Child>
)

export default FadeIn
